import { GridApi, GridOptions } from "@ag-grid-community/core";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Subject } from "rxjs";
import { LoadingCellRendererComponent } from "src/app/ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { SkuDetail } from "src/app/models/priceyard.model";

@Component({
  selector: "app-sku-mapping",
  templateUrl: "./sku-mapping.component.html",
  styleUrls: ["./sku-mapping.component.scss", "../mini-grid.scss"],
})
export class SkuMappingComponent implements OnInit,OnChanges, OnDestroy{
  @Input() sku: SkuDetail;
  @Output() viewEvent: EventEmitter<boolean> = new EventEmitter();
  gridApi: GridApi;
  @Input() mappings = [];
  @Input() financeData: any;
  @Input() isFinanceData = false;
  gridOptions:GridOptions;
  totalAmount:number = 0;
  private destroy$ = new Subject<void>();
  
  columnDefs = [
    { 
      field: "itemName",
      headerName: "Product",
    },
    {
      field: "qty",
      headerName: "Mapped Qty",
      valueGetter: (params) => {
        return (Number(params.data.qty) || 0).toLocaleString('en');
      },
    },
    {
      field: "avgPrice",
      headerName: "Avg. Price",
      valueFormatter: (param) => "$" + (param.value ?  (parseFloat(Number(param.value).toFixed(2))).toLocaleString('en') : "0.00"),
    },
    {
      field: "availStock",
      headerName: "Avail Stock",
      valueGetter: (params) => {
        return (Number(params.data.availStock) || 0).toLocaleString('en');
      },
    }
  ];
  financeColumnDefs:any = [
    {
      backendFields: ["settlementId"],
      width: 130,
      minWidth:130,  
      headerName:'settlement Ids',   
      field:'settlementId'
    },
    {
      field: "sku",
      backendFields: ["sku"],
      headerName: "Sku",
      width: 200
    },
   {
      field: "amountType",
      backendFields: ["amountType"],
      width: 60,  
      headerName:'Type'     
    },
    {
      field: "amountDescription", 
      backendFields: ["amountDescription"],    
      width: 125,
      minWidth:120,
      headerName:'Description'        
    },
    {
      field: "amount", 
      backendFields: ["amount"],    
      width: 125,
      minWidth:120,
      headerName:'Amount',
      sortable:true,
      sort:'desc',
      valueFormatter: (param) => "$" + (param.value ?  (parseFloat(Number(param.value).toFixed(2))).toLocaleString('en') : "0.00"),      
    },
    {
      field: "fFeeType", 
      backendFields: ["fFeeType"],    
      width: 125,
      minWidth:120,
      headerName:'Fee Type',
      hide:true       
    },
    {
      field: "fFeeAmount", 
      backendFields: ["fFeeAmount"],    
      width: 125,
      minWidth:120,
      headerName:'Fee Amount',
      hide: true        
    }
  ]

  components = {
    loadingCellRenderer: LoadingCellRendererComponent,
  };

  constructor() {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
   this.setAmountType()
  }

  setAmountType(){
    const index=this.financeColumnDefs.findIndex(res=>res.field == 'amountType')
    if(index != -1 && this.isFinanceData && this.gridApi){
     this.financeColumnDefs[index].hide= !(this.financeData?.type == 'SettlementEntries')
     this.gridApi.setGridOption('columnDefs', this.financeColumnDefs);  
    }
    if(this.financeData?.history?.length){
      this.totalAmount=0;
       this.financeData.history.forEach((el)=> {
        this.totalAmount += el.amount
       });
    }
  }

  ngOnInit(): void {
    this.gridOptions = {
      defaultColDef: {
        resizable: true,
        sortable:false
      },
      columnDefs: !this.isFinanceData ? this.columnDefs : this.financeColumnDefs,
      components: this.components,
      loadingCellRenderer: "loadingCellRenderer",
      onGridReady: (e) => {
        this.gridApi = e.api;
        this.gridApi.sizeColumnsToFit();
        this.setAmountType();
      },
      domLayout: "autoHeight",
    };
  }

  resized(e) {
    this.gridApi.sizeColumnsToFit();
  }

  edit() {
    this.viewEvent.emit(true);
  }
}
